import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import SignUp from "../../components/SignUp";
import SignIn from "../../components/SignIn";
import "./AuthUserContainer.css";
import billBoard from "../../assets/billboard.png";
import billBoardWithoutBg from "../../assets/billBoardwithoutbg.png";
import rightEllipse from "../../assets/rightEllipse.png";
import leftEllipse from "../../assets/o.png";
import { logoutUser } from "../../../toolkit/slices/users/userSlice";
import {
  clearAuthSession,
  hasStoredAuthSession,
} from "../../../../utils/authSession";

const AuthUserContainer = () => {
  const [signupFlag, setSignUpFlag] = useState(false);
  const [authReady, setAuthReady] = useState(
    process.env.NODE_ENV !== "development"
  );
  const dispatch = useDispatch();

  useEffect(() => {
    if (process.env.NODE_ENV !== "development") {
      return;
    }

    let cancelled = false;

    const prepareDevLogin = async () => {
      if (hasStoredAuthSession()) {
        await clearAuthSession();
        dispatch(logoutUser());
      }

      if (!cancelled) {
        setAuthReady(true);
      }
    };

    prepareDevLogin();

    return () => {
      cancelled = true;
    };
  }, [dispatch]);

  if (!authReady) {
    return null;
  }

  return (
    <>
      {/* <div className="auth-main-div">
        <div className="auth-main-left-section">
            <div>
                <div className="auth-logo"><img src="/images/yellowSpotLogo.svg" /></div>
                <div className="auth-main-img"><img src="/images/main.png" /></div>
                <div>
                    <div>Command Your Inventory</div>
                    <p>From Inventory Oversight to Client Relations, Our Platform Equips You with the Tools and Confidence to Navigate Every Aspect of Hoarding Management, Seamlessly.</p>
                </div>
            </div>
        </div>
        <div>{signupFlag ? <SignUp setSignUpFlag={setSignUpFlag} /> : <SignIn setSignUpFlag={setSignUpFlag} />}</div>
    </div> */}
      <div className="auth-main-div">
        <div className="board">
          {/* <div className="text-container" style={{textAlign:"center"}}>
            <p>
              Explore outdoor media in <b>Gujarat like never before</b>
            </p>
          </div> */}
          <img src={billBoardWithoutBg} />
        </div>
        <img className="right-ellipse" src={rightEllipse} />
        <img className="left-ellipse" src={leftEllipse} />
        <div>
          {signupFlag ? (
            <SignUp setSignUpFlag={setSignUpFlag} />
          ) : (
            <SignIn setSignUpFlag={setSignUpFlag} />
          )}
        </div>
      </div>
    </>
  );
};

export default AuthUserContainer;
